import useGetDebounceValue from '@vindr/utils/hooks/useGetDebounceValue';
import { Button, Checkbox, Col, Dropdown, Row } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const CheckboxMenu = ({
  clearValue = '*',
  height = 3,
  onChange,
  options,
  size,
  style,
  suffixIcon,
  timeout = 500,
  value,
}) => {
  const [selectedItems, setSelectedItems] = useState(value || null);
  const debounce = useGetDebounceValue(selectedItems, timeout);

  const { t } = useTranslation('Vindoc');

  useEffect(() => {
    if (Array.isArray(value)) {
      setSelectedItems(value);
    } else if (typeof value === 'string' && value === clearValue) {
      setSelectedItems([]);
    } else {
      setSelectedItems(value.split(','));
    }
  }, [`${debounce}`]);

  useEffect(() => {
    if (debounce.length) {
      onChange(debounce);
    }
  }, [`${debounce}`]);

  const handleOnChange = useCallback((selection) => {
    setSelectedItems(selection);
  }, []);

  const CheckboxRender = useCallback(() => {
    const groups = options
      .map((v, i) => (i % height === 0 ? options.slice(i, i + height) : null))
      .filter(Boolean);

    return (
      <Checkbox.Group onChange={handleOnChange} value={selectedItems} style={style}>
        <Row>
          {groups.map((group, index) => (
            <Col key={index} span={Math.floor(24 / height)}>
              {group.map((label) => (
                <Checkbox key={label} value={label}>
                  {label}
                </Checkbox>
              ))}
            </Col>
          ))}
        </Row>
        <Row>
          <Col span={12}>
            <Button size="small" onClick={() => handleOnChange(clearValue)}>
              {t('Clear')}
            </Button>
          </Col>
          <Col span={12}>
            <Button type="primary" size="small" onClick={() => onChange(selectedItems)}>
              {t('Apply')}
            </Button>
          </Col>
        </Row>
      </Checkbox.Group>
    );
  }, [`${selectedItems}`]);

  const SetSelectedItemsText = useCallback(() => {
    if (selectedItems?.length && !(selectedItems.length == 1 && selectedItems[0] == clearValue)) {
      return selectedItems.join(', ');
    }
    return t('Select');
  }, [`${selectedItems}`]);

  return (
    <Dropdown dropdownRender={() => <CheckboxRender />} trigger={['click']}>
      <Button
        size={size}
        style={{
          color:
            selectedItems.length && !(selectedItems.length == 1 && selectedItems[0] == clearValue)
              ? '#fff'
              : 'rgba(255, 255, 255, 0.3)',
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
        }}
      >
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <SetSelectedItemsText />
        </span>
        {suffixIcon}
      </Button>
    </Dropdown>
  );
};

export default CheckboxMenu;
